import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;

  gap: 12px;
  grid-auto-flow: column;
  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  padding: 12px 16px;

  background-color: ${Colors.GS300};
`

export const IconContainer = styled.div`
  position: relative;
  top: 2px;

  border-radius: 100%;

  background-color: black;

  color: rgba(30, 215, 96, 1);
`

export const Status = styled.div`
  margin-bottom: 2px;
`

export const Title = styled.div`
  font-weight: 600;
  line-height: 1.5;

  &:after {
    display: inline-block;
    animation: ellipsis steps(1, end) 3s infinite;
    content: '';

    @keyframes ellipsis {
      0% {
        content: '.';
      }
      33% {
        content: '..';
      }
      66% {
        content: '...';
      }
      100% {
        content: '.';
      }
    }
  }
`

export const Info = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
`
